module.exports = __webpack_public_path__ + "img/help19.ef8f326a.png";